<div fxLayout="column" fxLayoutGap="15px" class="facilities-list-container">
  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex="100">
      <button [disabled]="!(userPermissions | async).facility.write" (click)="addFacility()" mat-stroked-button color="primary"><mat-icon>add</mat-icon> <span> Dodaj placówkę</span></button>
    </div>
  </div>
  <table mat-table [dataSource]="dataSource">

    <!-- Position Column -->
    <ng-container matColumnDef="street">
      <th mat-header-cell *matHeaderCellDef> Ulica </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/placowki/szczegoly', element.address?.uuid]">{{element.address.street ? element.address.street : 'Brak nazwy ulicy'}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="houseNumber">
      <th mat-header-cell *matHeaderCellDef> Numer budynku </th>
      <td mat-cell *matCellDef="let element"> {{element.address.houseNumber}} </td>
    </ng-container>

    <ng-container matColumnDef="apartmentNumber">
      <th mat-header-cell *matHeaderCellDef> Numer mieszkania </th>
      <td mat-cell *matCellDef="let element">
        {{element.address.apartmentNumber}}
      </td>
    </ng-container>

    <ng-container matColumnDef="city">
      <th mat-header-cell *matHeaderCellDef> Miejscowość </th>
      <td mat-cell *matCellDef="let element">
        {{element.address.city}}
      </td>
    </ng-container>

    <ng-container matColumnDef="zipCode">
      <th mat-header-cell *matHeaderCellDef> Kod pocztowy </th>
      <td mat-cell *matCellDef="let element"> {{element.address.zipCode}} </td>
    </ng-container>

    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef > Województwo </th>
      <td mat-cell *matCellDef="let element" > {{element.address.state?.name}} </td>
    </ng-container>

    <ng-container matColumnDef="activeOfwcas">
      <th mat-header-cell *matHeaderCellDef > Aktywne OFWCA </th>
      <td mat-cell *matCellDef="let element" > {{element.activeOfwcas}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu"><mat-icon>expand_more</mat-icon></button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!(userPermissions | async).facility.delete" mat-menu-item (click)="deleteFacility(element)">Usuń</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
</div>
